import { Component } from 'react';
import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import building from '../../../assets/img/building.jpeg';

class BuildingImage extends Component {
    constructor(props) {
        super(props);

        if(this.props.id) {
             const address = this.props.addresses.find( address => (address != null ? address.dp_address_id === this.props.id : false) );
             //const address = lodash.find(this.props.addresses, function(value, dp_address_id) { return value ? value.dp_address_id === dp_address_id : false; });
             this.state = {
                address
             }
        }
    }
    componentDidMount() {

    }

    componentDidUpdate(prevProps, prevState) {

        const address = this.props.addresses.find( address => (address != null ? address.dp_address_id === this.props.id : false ));
        if(this.state.address !== address) {
            this.setState({
                address
            })
        }


    }
    render() {
        const buildingImage = this.state.address ? this.state.address.address_image : "https://mijndp.dp.nl/image/api/building.jpeg";
        let refreshClass = '';
        return (

            <div className={"single__address__image " + refreshClass } style={{backgroundImage: 'url('+buildingImage+')'}}>
            	<div className="single__address__image__update" onClick={() => this.props.openFilePopup()}>
            		<i className="fa fa-pencil"></i>
            	</div>
            </div>


        );
    }
}

function mapStateToProps(state) {
  return {
    addresses: state.AddressReducer.addresses,
    searchData: state.SearchDataReducer
  }
}

const mapDispatchToProps = (dispatch) => {
  return {

    };
};


export default withRouter(connect(mapStateToProps, mapDispatchToProps, false, {pure: false})(BuildingImage));



// WEBPACK FOOTER //
// ./src/components/Addresses/BuildingImage/index.js